var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaoLoginIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#FAE64C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 42C40.0751 42 45 38.1944 45 33.5C45 28.8056 40.0751 25 34 25C27.9249 25 23 28.8056 23 33.5C23 36.3345 24.7955 38.8449 27.5555 40.3892C27.6329 40.4326 27.674 40.5212 27.6554 40.6079L26.599 45.5382C26.5619 45.7109 26.7507 45.8433 26.9005 45.7497L32.9046 41.9971C32.9406 41.9746 32.9828 41.9642 33.0251 41.9671C33.3463 41.9889 33.6715 42 34 42Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoLoginIcon);
export default __webpack_public_path__ + "static/media/kakaoLoginIcon.a97fd31a.svg";
export { ForwardRef as ReactComponent };